import React from 'react';
interface SectionHeadingProps {
  title: string;
  eyebrow: string;
  intro?: string;
  align?: 'left' | 'center';
}
export function SectionHeading({
  title,
  eyebrow,
  intro,
  align = 'center'
}: SectionHeadingProps) {
  return <div className={`mb-12 ${align === 'center' ? 'text-center' : 'text-left'}`} data-id="element-288">
      <span className="eyebrow block mb-4" data-id="element-289">{eyebrow}</span>
      <h2 className="text-4xl md:text-5xl mb-6" data-id="element-290">{title}</h2>
      {intro && <p className={`text-xl text-club-ink/80 font-light leading-relaxed ${align === 'center' ? 'mx-auto max-w-3xl' : 'max-w-3xl'}`} data-id="element-291">
          {intro}
        </p>}
    </div>;
}